import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';
import { getSeoBaseUrl } from '../../utils/api';
import AuthBounceSpinner from '../Auth/AuthBounceSpinner';

export default function AdminRoute({ children }) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) return <AuthBounceSpinner />;

  // Sign-in is in the Next.js seo app at a different origin in dev — see ProtectedRoute for the same pattern.
  if (!isAuthenticated) {
    if (typeof window !== 'undefined') {
      window.location.replace(`${getSeoBaseUrl()}/sign-in`);
    }
    return <AuthBounceSpinner />;
  }

  // Only superadmin role can access admin routes
  if (user?.role !== 'superadmin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
